import { GuardianPath, GuardianPathInfo } from "../types/faction"

export const GUARDIAN_PATH_ORDER: GuardianPath[] = [
  "STRAZH",
  "SLEDOPYT",
  "MASTER",
  "TAKTIK",
  "NASTAVNIK",
  "OKHOTNIK",
]

export const GUARDIAN_PATH_DEFAULTS: Record<GuardianPath, GuardianPathInfo> = {
  STRAZH: {
    path: "STRAZH",
    title: "Страж",
    description: "Дуэли — моя стихия. Больше монет за победы.",
  },
  SLEDOPYT: {
    path: "SLEDOPYT",
    title: "Следопыт",
    description: "Карта города — мой клад. Скан приносит больше.",
  },
  MASTER: {
    path: "MASTER",
    title: "Мастер",
    description: "Кую карты. Дешевле прокачка, больше с босс-квестов.",
  },
  TAKTIK: {
    path: "TAKTIK",
    title: "Тактик",
    description: "Побеждаю колодой. Дуэли колодой окупаются.",
  },
  NASTAVNIK: {
    path: "NASTAVNIK",
    title: "Наставник",
    description: "Знание — сила. Тесты и квизы дают больше.",
  },
  OKHOTNIK: {
    path: "OKHOTNIK",
    title: "Охотник",
    description: "Иду на боссов. Охота платит монетами и картами.",
  },
}

export const GUARDIAN_PATH_ACCENTS: Record<GuardianPath, string> = {
  STRAZH: "#EF4444",
  SLEDOPYT: "#22C55E",
  MASTER: "#F97316",
  TAKTIK: "#8B5CF6",
  NASTAVNIK: "#38BDF8",
  OKHOTNIK: "#DC2626",
}

export function isGuardianPath(value: unknown): value is GuardianPath {
  return (
    typeof value === "string" &&
    GUARDIAN_PATH_ORDER.includes(value.toUpperCase() as GuardianPath)
  )
}

export function normalizeGuardianPath(value: unknown): GuardianPath | null {
  if (!isGuardianPath(value)) return null
  return value.toUpperCase() as GuardianPath
}

export function formatGuardianPathLabel(path: GuardianPath | null | undefined): string {
  if (!path) return "—"
  return GUARDIAN_PATH_DEFAULTS[path]?.title ?? path
}
